import { FormField } from '../../../types/form-builder.types';
import { cn } from '@shondalai/ui-commons';

interface RadioFieldProps {
  field: FormField;
  value: any;
  onChange: (value: any) => void;
  error?: string;
}

export function RadioField({ field, value, onChange }: RadioFieldProps) {
  const config = field.config;
  const options = config.options || [];
  const layout = config.choiceLayout || 'vertical';

  return (
    <div
      className={cn(
        "easyforms-options-group",
        layout === 'horizontal' && "flex flex-wrap gap-3",
        layout === 'grid' && `grid grid-cols-${config.columns || 2} gap-3`
      )}
    >
      {options.map((option, index) => (
        <div key={option.id || option.value || `radio-${index}`} className="easyforms-option-item">
          <input
            type="radio"
            name={field.id}
            value={option.value}
            id={`${field.id}-${option.value}`}
            checked={value === option.value}
            onChange={(e) => onChange(e.target.value)}
            className="easyforms-option-input"
          />
          <label
            htmlFor={`${field.id}-${option.value}`}
            className="easyforms-option-label"
          >
            {option.label}
          </label>
        </div>
      ))}
    </div>
  );
}
